
export enum ProjectAssessmentStatusEnum {
    pending = "pending",
    approved = "approved",
    rejected = "rejected"
};
export interface IProject {
    id: number,
    strategic_plan_id: number,
    in_charge_id: number,
    in_charge_data_entry_id: number,
    in_charge_data_entry_name: string,
    progress_percentage: number,

    name: string,
    name_en?: string,
    goals: string,
    target_audience: string,
    description: string,
    description_en?: string,
    targets: string,
    success_factors: string,
    kpis: string,
    urgent_need: string,

    // new v2
    is_ready_to_submit: boolean,
    positive_effects: string,
    supporting_models_studies: string,

    start_date: Date,
    end_date: Date,
    created_at: number,
    updated_at: number,
    deleted_at: number,
    is_deleted: boolean,
    code: string,
    assessment_status: ProjectSubmissionStatusEnum
    is_on_hold: boolean,
    strategicLinks: IProjectStrategicLinkItem[],
    govLinks: IProjectGovLinkItem[],


    // EXTRA
    project_unit_id: number,
    // inChargeData: IUser,
    // unitData: ISection,
    // projectResource: IProjectResource,
    // projectMappings: [IProjectMapping],
    // depData: IDepartment,
    // indicatorData: IStrategicIndicator,
    // proofUpload: Express.Multer.File,
    // proofs: [IProjectProofMediaFile],
    // inChargeUnitData: Partial<ISection> | Partial<IDepartment>,
    // statusCases: Partial<StatusMap<boolean | string>>,
    // status: ProjectStatusEnum,
    // in_charge_unit_name: string,
    is_2023_project: boolean,
    // projectAssessments: [IProjectAssessment],
    assessment_status_name: string,
    assessment_score: number,
    department_name: string,
    section_name: string,
    stakeholder?: IStakeholder
    resource?: IProjectResource;
    projectResource?: IProjectResource;
    assessments?: ISubmission[];
    is_submitted: boolean;
    IS_ALLOWED_TO_DELETE: boolean;
    IS_ALLOWED_TO_UPDATE: boolean;
    IS_ALLOWED_TO_VIEW: boolean;
    IS_READ_ONLY: boolean;
    weight: number;
};
// موارد المشروع
export interface IProjectResource {
    id: number,
    project_id: number,
    is_within_budget_limit: string,
    estimated_budget: number,
    sponsor_engagement: string,
    required_internal_resources: string,
    required_external_resources: string,
    rationalization_method: string,
    budget_items: [],
    created_at: number,
    updated_at: number,
    deleted_at: number,
    is_deleted: boolean
};

export enum ProjectGovLinkTypesEnum {
    emirate = "emirate",
    state = "state"
};
export interface IProjectGovLinkItem {
    goal_type: ProjectGovLinkTypesEnum,
    goal_description: string,
    goal_reference: string,
    reference_file: boolean,
    isEmpty: boolean,
    isValid: boolean
};
export interface IProjectStrategicLinkItem {
    strategic_goal_id: number,
    strategic_indicator_id: number,
    strategic_goal_name: string,
    strategic_indicator_name: string,
    is_deleted: boolean,
    id: number
};
export interface IStakeholder {
    id: number
    project_id: number
    entity_in_charge_id: number
    entity_in_charge_type: string
    executive_in_charge_id: number
    supporting_units: any[]
    support_in_charge: string
    partners: string
    partners_link_description: string
    supporters: string
    supporters_link_description: string
    created_at: Date
    updated_at: Date
    deleted_at: Date
    is_deleted: boolean

}

export interface IUpdateStakeholderPayload {
    id: number
    project_id: number
    entity_in_charge_id: number
    entity_in_charge_type: string
    executive_in_charge_id: number
    supporting_units: { type: string; id: number }[]
    support_in_charge: string
    partners: string
    partners_link_description: string
    supporters: string
    supporters_link_description: string
}
export interface ITeamMember {
    id: number
    user_id: number
    project_id: number
    activity: string
    is_primary_connection: boolean
    created_at: string
    updated_at: string
    deleted_at: any
    is_deleted: boolean
    name: string
    member_role: string
    job_title: string
    department_name: string
    is_in_charge?: boolean
    unit_type?: string
    unit_id?: number
}
export interface IRisk {
    id: number
    project_id: number
    in_charge_name: string
    type: string
    likelihood: string
    impact: string
    weight: number
    action: string
    name: string
    description: string
    created_at: string
    updated_at: string
    deleted_at: any
    is_deleted: boolean
    likelihood_name: string
    impact_name: string
    type_name: string
    weight_color: string,
    risk_identification_date: any,
    expected_risk_closure_date: any,
    actual_risk_closure_date: any
}
export interface IMilestone {
    id: number
    project_id: number
    name: string
    description: string
    outputs: string
    start_date: any
    end_date: any
    indicator_name: string
    is_done: boolean | null
    is_positive: any
    is_notified: boolean
    created_at: string
    updated_at: string
    deleted_at: any
    is_deleted: boolean
    limit: number
    current: number
    left: number
    is_allowed_to_upload: boolean,
    parent_milestone_id: number | null;
    subMilestones: IMilestone[]
    execution_responsibility?: string | null
    actual_completion_date?: any
    estimated_cost?: number | null
    completion_percentage?: number | null
    completion_status?: string | null
}
export interface Icriteria {
    name: string
    maxScore: number
    score: number
    notes: string
}
export interface ISubmission {
    id: number
    project_id: number
    score: number
    status: string
    criterias: Icriteria[]
    reasons: any
    is_main: boolean
    version: number
    no_submits: number
    is_assessed: boolean
    created_at: string
    updated_at: string
    deleted_at: any
    is_deleted: boolean
    project_name: string
}
export enum ProjectSubmissionStatusEnum {
    pending = "pending",
    approved = "approved",
    rejected = "rejected",
    draft = "draft"
};


export const levelValues = {
    'very_high': 5,
    'high': 4,
    'medium': 3,
    'low': 2,
    'very_low': 1
} as any;


export const levelNames = {
    'very_high': "مرتفع جدا",
    'high': "مرتفع",
    'medium': "متوسط",
    'low': "ضعيف",
    'very_low': "ضعيف جدا"
} as any;